import React, { lazy, Suspense } from 'react';
import { Platform } from 'react-native';

// Import directly on web to avoid lazy loading issues with module resolution
const DirectMemoizedMarker = Platform.OS === 'web' ? require('./MemoizedMarker').default : null;
const LazyMemoizedMarker = Platform.OS !== 'web' ? lazy(() => import('./MemoizedMarker')) : null;

/**
 * Lazy loads the MemoizedMarker component.
 * Note, no suspense component is shown, results in a gradual initial pin load.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.pantry - The pantry object.
 * @param {number} props.selectedPantryId - The active pantry id.
 * @param {function} props.showPantryDetails - Function to show pantry details.
 * @param {function} props.selectPantry - Function to select a pantry.
 * @param {function} props.getIcon - Function to get the pantry icon.
 * @returns {React.Element} - Returns a React element representing a MemoizedMarker.
 */
const LazyLoadMarker = (props) => {
  if (Platform.OS === 'web') {
    // Use direct import on web to avoid lazy loading module resolution issues
    return <DirectMemoizedMarker {...props} />;
  }

  return (
    <Suspense>
      <LazyMemoizedMarker {...props} />
    </Suspense>
  );
};

export default LazyLoadMarker;
